// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".discountYouSave .additionalInfo .inclVat {\n  float: right;\n}", "",{"version":3,"sources":["/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/src/components/additionalInfo.vue"],"names":[],"mappings":"AAGI;EACE,YAAA;AAFN","file":"additionalInfo.vue","sourcesContent":["\n.discountYouSave {\n  .additionalInfo {\n    .inclVat {\n      float:right;\n    }\n  }\n}\n"]}]);
// Exports
module.exports = exports;
